import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";

import CustomDatePicker from "../../ReuseableCompos/CustomDatePicker";

const DatePickerModal = ({
  handleDatePickerModalClose,
  showDatePickerModal,

  onSelectedDate,
}) => {
  const [startDate, setStartDate] = useState(new Date());

  const { query } = useRouter();

  useEffect(() => {
    setStartDate(new Date(dateFormatter(query?.date as string)));
  }, [query?.date]);
  const onDatePickerChange = (date: Date) => {
    setStartDate(date);
    onSelectedDate(date);
  };
  return (
    <Modal
      show={showDatePickerModal}
      onHide={handleDatePickerModalClose}
      centered
      className="date-picker-modal"
    >
      <Modal.Body>
        <StyledTransparencyDatePicker>
          <CustomDatePicker
            minDate={new Date("11/11/2015")}
            maxDate={new Date()}
            startDate={startDate}
            onChange={onDatePickerChange}
            inline
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </StyledTransparencyDatePicker>
      </Modal.Body>
    </Modal>
  );
};

export default DatePickerModal;

const StyledTransparencyDatePicker = styled.div``;
function dateFormatter(date: string) {
  return `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
}
